export const EQUALS = 'EQUALS';
export const NOT_EQUALS = 'NOT_EQUALS';
export const GREATER_THAN = 'GREATER_THAN';
export const GREATER_THAN_EQUALS = 'GREATER_THAN_EQUALS';
export const LESS_THAN = 'LESS_THAN';
export const LESS_THAN_EQUALS = 'LESS_THAN_EQUALS';
// export const BETWEEN = 'BETWEEN';
// export const NOT_BETWEEN = 'NOT_BETWEEN';
// export const LIKE = 'LIKE';
// export const NOT_LIKE = 'NOT_LIKE';
// export const CONTAINS = 'CONTAINS';
// export const DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN';

export const getOperatorsString = (operand, value, name) => {
  if (!Array.isArray(value)) {
    switch (operand) {
      case EQUALS:
        return `${name}:${value}`;

      case NOT_EQUALS:
        return `NOT ${name}:${value}`;

      case GREATER_THAN:
        return `${name}:>${value}`;

      case GREATER_THAN_EQUALS:
        return `${name}:>=${value}`;

      case LESS_THAN:
        return `${name}:<${value}`;

      case LESS_THAN_EQUALS:
        return `${name}:<=${value}`;

      default:
        return;
    }
  } else if (Array.isArray(value) && value.length > 0) {
    let newFilterString = '';
    switch (operand) {
      case EQUALS:
        value.forEach((v, i) => {
          if (value.length - 1 === i) {
            newFilterString = newFilterString + `${name}:${v}`;
          } else {
            newFilterString = newFilterString + `${name}:${v} OR `;
          }
        });
        break;

      case NOT_EQUALS:
        value.forEach((v, i) => {
          if (value.length - 1 === i) {
            newFilterString = newFilterString + `NOT ${name}:${v}`;
          } else {
            newFilterString = newFilterString + `NOT ${name}:${v} OR `;
          }
        });
        break;

      case GREATER_THAN:
        value.forEach((v, i) => {
          if (value.length - 1 === i) {
            newFilterString = newFilterString + `${name}:>${v}`;
          } else {
            newFilterString = newFilterString + `${name}:>${v} OR `;
          }
        });
        break;

      case GREATER_THAN_EQUALS:
        value.forEach((v, i) => {
          if (value.length - 1 === i) {
            newFilterString = newFilterString + `${name}:>=${v}`;
          } else {
            newFilterString = newFilterString + `${name}:>=${v} OR `;
          }
        });
        break;

      case LESS_THAN:
        value.forEach((v, i) => {
          if (value.length - 1 === i) {
            newFilterString = newFilterString + `${name}:<${v}`;
          } else {
            newFilterString = newFilterString + `${name}:<${v} OR `;
          }
        });
        break;

      case LESS_THAN_EQUALS:
        value.forEach((v, i) => {
          if (value.length - 1 === i) {
            newFilterString = newFilterString + `${name}:<=${v}`;
          } else {
            newFilterString = newFilterString + `${name}:<=${v} OR `;
          }
        });
        break;

      default:
        break;
    }

    return `${newFilterString}`;
  }
};
